(() => {
  const A = window.AURELLE || { products: {}, free: 2900, pack: 15 };
  const P = A.products;
  const PACK = A.pack || 15;
  const KIT = 'full-care-aurelle', NUTRI = 'nutri-care-aurelle', SCALP = 'scalp-care-aurelle';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const eur = c => (c / 100).toFixed(2).replace('.', ',') + '€';
  const cap = s => s[0].toUpperCase() + s.slice(1);
  const packPrice = c => 2 * (c - Math.floor(c * PACK / 100));
  const kitSave = it => (P[KIT] && P[KIT].compare > P[KIT].price) ? (P[KIT].compare - P[KIT].price) * it.quantity : 0;
  /* Cart reservation timer (same logic as Qure): the end time lives in sessionStorage.
     Reused while it is in the future; once expired the bar says so, and the next page load starts a new one.
     Emptying the cart clears it. */
  const RES_KEY = 'cart-reservation-timer-end', RES_MIN = A.reserveMin || 10;
  const resolveEnd = () => { try { const st = Number(sessionStorage.getItem(RES_KEY)) || 0; if (st > Date.now()) return st; const end = Date.now() + RES_MIN * 60000; sessionStorage.setItem(RES_KEY, end); return end; } catch (e) { return Date.now() + RES_MIN * 60000; } };
  const resClear = () => { try { sessionStorage.removeItem(RES_KEY); } catch (e) {} };
  let resEnd = 0, resExpired = false;
  const fmtLeft = ms => { const s = Math.max(0, Math.floor(ms / 1000)); return String(Math.floor(s / 60)).padStart(2, '0') + ':' + String(s % 60).padStart(2, '0'); };
  const tickRes = () => {
    const t = document.getElementById('dTimer'); if (!t || !resEnd) return;
    const left = resEnd - Date.now();
    if (left <= 0) { resExpired = true; t.textContent = 'Tempo scaduto!'; t.classList.add('up'); return; }
    t.textContent = fmtLeft(left);
  };
  setInterval(tickRes, 1000);
  const ARROW = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';

  /* Colours of a variant: kit -> [nutri, scalp], single -> [colour]. Reads "Nutri Rosa · Scalp Bianco" or the older "Rosa+Bianco". */
  function dots(h, title) {
    const t = String(title).toLowerCase();
    if (h === KIT) {
      const m = t.match(/nutri\s+(rosa|bianco).*scalp\s+(rosa|bianco)/);
      if (m) return [m[1], m[2]];
      const parts = t.split('+').map(s => s.trim());
      return [parts[0].includes('rosa') ? 'rosa' : 'bianco', (parts[1] || parts[0]).includes('rosa') ? 'rosa' : 'bianco'];
    }
    return [t.includes('rosa') ? 'rosa' : 'bianco'];
  }
  function defIndex(h) {
    const p = P[h]; if (!p || !p.variants.length) return 0;
    if (h === KIT) { const i = p.variants.findIndex(v => dots(h, v.title).join() === 'rosa,rosa' && v.available); if (i > -1) return i; }
    const i = p.variants.findIndex(v => v.available);
    return i > -1 ? i : 0;
  }

  /* ---------- announcement + menu ---------- */
  const ANN = ['Spedizione gratuita sopra i 29€', `Prendine 2: −${PACK}% su Nutri Care e Scalp Care`, 'Soddisfatta o rimborsata entro 30 giorni'];
  if (P[KIT] && P[KIT].compare > P[KIT].price) ANN.splice(1, 0, `Kit Full Care a ${eur(P[KIT].price)}: risparmi ${eur(P[KIT].compare - P[KIT].price)} sui singoli prodotti`);
  let ai = 0; const ann = $('#ann');
  if (ann) setInterval(() => { ann.style.opacity = 0; setTimeout(() => { ai = (ai + 1) % ANN.length; ann.textContent = ANN[ai]; ann.style.opacity = 1; }, 400); }, 4200);
  const burger = $('#burger'), mm = $('#mmenu');
  if (burger) burger.onclick = () => { mm.hidden = !mm.hidden; burger.setAttribute('aria-expanded', String(!mm.hidden)); };

  /* ---------- cart ---------- */
  const drawer = $('#drawer'), scrim = $('#scrim');
  const openCart = () => { drawer.classList.add('on'); scrim.classList.add('on'); drawer.setAttribute('aria-hidden', 'false'); };
  const closeCart = () => { drawer.classList.remove('on'); scrim.classList.remove('on'); drawer.setAttribute('aria-hidden', 'true'); };
  $('#openCart').addEventListener('click', e => { e.preventDefault(); openCart(); refresh(); });
  $('#closeCart').onclick = closeCart; scrim.onclick = closeCart;
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeCart(); });
  let tt; const toast = m => { const t = $('#toast'); t.textContent = m; t.classList.add('on'); clearTimeout(tt); tt = setTimeout(() => t.classList.remove('on'), 2400); };

  const api = (url, body) => fetch(url, body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' } })
    .then(async r => { const j = await r.json(); if (!r.ok) throw new Error(j.description || j.message || 'Errore'); return j; });
  const refresh = () => api('/cart.js').then(render).catch(() => {});

  function render(c) {
    const cnt = $('#count'); cnt.textContent = c.item_count; cnt.dataset.n = c.item_count;
    const dc = $('#dCount'); if (dc) dc.textContent = c.item_count ? `(${c.item_count})` : '';
    if (c.item_count) { if (!resEnd && !resExpired) resEnd = resolveEnd(); } else { resClear(); resEnd = 0; resExpired = false; }
    const bar = $('#dBar'); if (bar) { bar.hidden = !c.item_count; bar.innerHTML = `<span><strong>MOLTO RICHIESTO</strong> | Carrello riservato per:</span> <b id="dTimer">${resEnd ? fmtLeft(resEnd - Date.now()) : ''}</b>`; tickRes(); }
    const tot = c.total_price;
    /* A cart with only the digital guide ships nothing. */
    const phys = c.items.filter(i => i.requires_shipping), physTot = tot; /* Shopify's 29€ threshold counts the whole cart */
    const pct = Math.min(100, physTot / A.free * 100);
    const shipEl = $('#ship'); shipEl.hidden = c.item_count > 0 && !phys.length;
    shipEl.innerHTML = (physTot >= A.free
      ? '<div class="row"><span>🎉 Hai la <b>spedizione gratuita</b></span><span>29€</span></div>'
      : `<div class="row"><span>Ancora <b>${eur(A.free - physTot)}</b> per la spedizione gratuita</span><span>29€</span></div>`) + `<div class="bar"><i style="width:${pct}%"></i></div>`;
    const L = $('#lines'), F = $('#dfoot');
    if (!c.item_count) {
      L.innerHTML = `<div class="empty"><h3>Il carrello è vuoto</h3><p style="color:var(--ink-2)">Inizia dal Kit Full Care: la routine completa a ${P[KIT] ? eur(P[KIT].price) : ''}.</p><a class="btn" href="/products/full-care-aurelle">Scopri il kit</a></div>`;
      F.innerHTML = ''; return;
    }
    L.innerHTML = c.items.map((it, i) => {
      const ks = it.handle === KIT ? kitSave(it) : 0;
      const was = ks > 0 ? it.final_line_price + ks : (it.original_line_price > it.final_line_price ? it.original_line_price : 0);
      return `
      <div class="line">${it.image ? `<img src="${it.image}" alt="">` : '<span></span>'}
        <div><b>${it.handle === KIT ? 'Kit Full Care' : it.product_title}</b>${it.variant_title ? `<span class="vt" style="margin-bottom:2px">${it.variant_title}</span>` : ''}<span class="ok">Disponibile</span>
          <div class="qrow"><div class="qty"><button data-line="${i + 1}" data-q="${it.quantity - 1}" aria-label="Diminuisci">−</button><output>${it.quantity}</output><button data-line="${i + 1}" data-q="${it.quantity + 1}" aria-label="Aumenta">+</button></div>
          <button class="rm" data-line="${i + 1}" data-q="0">Rimuovi</button></div></div>
        <div class="price">${eur(it.final_line_price)}${was ? `<s>${eur(was)}</s><span class="sv">Risparmi ${eur(was - it.final_line_price)}</span>` : ''}</div></div>`;
    }).join('');
    /* One recommendation only. */
    const qtyOf = h => c.items.filter(i => i.handle === h).reduce((s, i) => s + i.quantity, 0);
    let rec = '';
    if (P[KIT] && qtyOf(NUTRI) >= 1 && qtyOf(SCALP) >= 1 && !qtyOf(KIT)) {
      rec = `<div class="d-up"><img src="${P[KIT].imgs[1] || P[KIT].imgs[0]}" alt=""><span><b>Kit Full Care</b>${eur(P[KIT].price)} · guida in regalo</span><a href="${P[KIT].url}">Scopri</a></div>`;
    } else {
      const one = c.items.find(i => (i.handle === NUTRI || i.handle === SCALP) && qtyOf(i.handle) === 1);
      if (one && P[one.handle]) {
        const p = P[one.handle];
        rec = `<div class="d-up"><img src="${p.imgs[1] || p.imgs[0]}" alt=""><span><b>Un secondo ${p.name}</b>−${PACK}% su entrambi</span><button data-addv="${one.variant_id}">Aggiungi</button></div>`;
      } else if (!qtyOf(KIT) && P[KIT]) {
        rec = `<div class="d-up"><img src="${P[KIT].imgs[1] || P[KIT].imgs[0]}" alt=""><span><b>Kit Full Care</b>${eur(P[KIT].price)} · guida in regalo</span><a href="${P[KIT].url}">Scopri</a></div>`;
      }
    }
    if (rec) L.insertAdjacentHTML('beforeend', `<div class="d-rec"><h4>Completa la routine</h4>${rec}</div>`);
    const discounts = c.items.reduce((s, i) => s + (i.original_line_price - i.final_line_price), 0);
    const saved = discounts + c.items.filter(i => i.handle === KIT).reduce((s, i) => s + kitSave(i), 0);
    const shipFree = physTot >= A.free;
    F.innerHTML = `${phys.length ? `<div class="tot" style="font-weight:400;color:var(--ink-2)"><span>Spedizione</span><span>${shipFree ? 'Gratuita' : '2,90€'}</span></div>` : `<div class="tot" style="font-weight:400;color:var(--ink-2)"><span>Consegna</span><span>Download immediato</span></div>`}
      ${saved > 0 ? `<div class="tot" style="font-weight:600;color:var(--rose-deep)"><span>Risparmi</span><span>−${eur(saved)}</span></div>` : ''}
      <div class="tot big"><span>Totale</span><span class="price">${eur(tot)}</span></div>
      <a class="btn block" href="/checkout">Vai al pagamento <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="5" y="10.5" width="14" height="10" rx="2.5"/><path d="M8.5 10.5V7.5a3.5 3.5 0 0 1 7 0v3"/></svg></a>
      <div class="d-guar"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3l7 3v5c0 4.5-3 8.3-7 10-4-1.7-7-5.5-7-10V6z"/><path d="M8.8 12.2l2.2 2.2 4.2-4.6"/></svg>Soddisfatta o rimborsata entro 30 giorni</div>`;
  }
  $('#lines').addEventListener('click', e => {
    const v = e.target.closest('[data-addv]');
    if (v) { add(+v.dataset.addv, 1, v); return; }
    const b = e.target.closest('[data-line]'); if (!b) return;
    api('/cart/change.js', { line: +b.dataset.line, quantity: Math.max(0, +b.dataset.q) }).then(render).catch(err => toast(err.message));
  });
  function addItems(items, btn) {
    if (btn) btn.disabled = true;
    return api('/cart/add.js', { items })
      .then(() => refresh()).then(openCart)
      .catch(err => toast(err.message))
      .finally(() => { if (btn) btn.disabled = false; });
  }
  const add = (id, qty = 1, btn) => addItems([{ id, quantity: qty }], btn);
  document.addEventListener('click', e => {
    const q = e.target.closest('[data-quick]'); if (!q) return;
    const p = P[q.dataset.quick]; if (!p) return;
    e.preventDefault(); add(p.variants[defIndex(q.dataset.quick)].id, 1, q);
  });

  /* ---------- product page ---------- */
  const pdp = $('[data-pdp]');
  if (pdp && P[pdp.dataset.pdp]) {
    const h = pdp.dataset.pdp, p = P[h];
    let vi = defIndex(h);
    const cur = [...dots(h, p.variants[vi].title)];
    if (h !== KIT) cur.push(cur[0]);
    let pack = 1;
    const idInput = $('input[name="id"]', pdp), main = $('#mainImg'), qv = $('#qv');
    let q = 1;
    const vFor = c => { const i = p.variants.findIndex(v => dots(h, v.title)[0] === c); return i > -1 ? i : vi; };
    const setImg = i => { if (!main || !p.imgs[i]) return; main.removeAttribute('srcset'); main.src = p.imgs[i]; $$('[data-thumb]').forEach(t => t.setAttribute('aria-pressed', String(+t.dataset.thumb === i))); };
    const label = () => pack === 2 ? `Aggiungi 2 pezzi · ${eur(packPrice(p.price))}` : `Aggiungi · ${eur(p.price)}`;
    const sync = () => {
      $$('[data-g]', pdp).forEach(b => b.setAttribute('aria-pressed', String(cur[+b.dataset.g] === b.dataset.c)));
      $$('[data-gl]', pdp).forEach(s => s.textContent = cap(cur[+s.dataset.gl]));
      $$('[data-gi]', pdp).forEach(im => { const src = P[+im.dataset.gi === 0 ? NUTRI : SCALP]; if (src) im.src = src.imgs[cur[+im.dataset.gi] === 'bianco' ? 0 : 1] || im.src; });
      $$('[data-pack]', pdp).forEach(b => b.setAttribute('aria-pressed', String(+b.dataset.pack === pack)));
      const second = $('#piece2'); if (second) second.hidden = pack !== 2;
      const pl = $('#piece2line'); if (pl) pl.hidden = pack !== 2;
      $$('[data-pi]', pdp).forEach(im => { const src = p.imgs[cur[+im.dataset.pi] === 'bianco' ? 0 : 1]; if (src) im.src = src; });
      const ps = $('#packSum'); if (ps) ps.textContent = pack === 2 ? `${cap(cur[0])} + ${cap(cur[1])}` : `1 × ${cap(cur[0])}`;
      const pt = $('#packTot'); if (pt) pt.textContent = pack === 2 ? eur(packPrice(p.price)) : eur(p.price);
      const pw = $('#packWas'); if (pw) pw.hidden = pack !== 2;
      const sh = $('#packShip'); if (sh) sh.textContent = pack === 2 && packPrice(p.price) >= (A.free || 0) ? 'Gratuita' : sh.dataset.one;
      const qr = $('#addForm .qty'); if (qr) qr.hidden = pack === 2;
      const k = $('#kitSum'); if (k) k.textContent = p.variants[vi].title;
      if (idInput) idInput.value = p.variants[vi].id;
      const ab = $('#addBtn');
      const avail = p.variants[vi].available && (pack === 1 || p.variants[vFor(cur[1])].available);
      ab.disabled = !avail;
      ab.firstElementChild.textContent = !avail ? 'Esaurito' : h === KIT ? 'Aggiungi il mio kit' : pack === 2 ? 'Aggiungi 2 pezzi' : 'Aggiungi al carrello';
      const ap = $('#addPrice'); if (ap) ap.textContent = pack === 2 ? eur(packPrice(p.price)) : eur(p.price);
      const sa = $('#sbAdd'); if (sa) sa.textContent = label();
    };
    $$('[data-g]', pdp).forEach(b => b.onclick = () => {
      const g = +b.dataset.g;
      cur[g] = b.dataset.c;
      if (h === KIT) { const i = p.variants.findIndex(v => dots(h, v.title).join() === cur.slice(0, 2).join()); if (i > -1) vi = i; setImg(vi); }
      else if (g === 0) { vi = vFor(cur[0]); setImg(vi); }
      else setImg(vFor(cur[1]));
      sync();
    });
    $$('[data-pack]', pdp).forEach(b => b.onclick = () => { pack = +b.dataset.pack; sync(); });
    $$('[data-thumb]').forEach(t => t.onclick = () => setImg(+t.dataset.thumb));
    $('#qm').onclick = () => { q = Math.max(1, q - 1); qv.textContent = q; };
    $('#qp').onclick = () => { q++; qv.textContent = q; };
    const buy = btn => {
      if (pack === 2 && h !== KIT) {
        const a = p.variants[vi].id, b = p.variants[vFor(cur[1])].id;
        return addItems(a === b ? [{ id: a, quantity: 2 }] : [{ id: a, quantity: 1 }, { id: b, quantity: 1 }], btn);
      }
      return add(p.variants[vi].id, q, btn);
    };
    $('#addForm').addEventListener('submit', e => { e.preventDefault(); buy($('#addBtn')); });
    const sb = $('#stickyBuy');
    sb.innerHTML = `<b>${p.name}</b><button class="btn" id="sbAdd">${label()}</button>`;
    $('#sbAdd').onclick = e => buy(e.currentTarget);
    new IntersectionObserver(([en]) => sb.classList.toggle('on', !en.isIntersecting && en.boundingClientRect.top < 0)).observe($('#addBtn'));
    sync(); setImg(vi);
  }

  /* ---------- quiz ---------- */
  const quiz = $('#quiz');
  if (quiz) {
    const Q = [
      { q: 'Usi già un siero o un olio per il cuoio capelluto?', o: [['Sì, regolarmente', 'serum'], ['Ogni tanto', 'some'], ['Non ancora', 'none']] },
      { q: 'Cosa ti pesa di più della tua routine attuale?', o: [['Il prodotto finisce sulle lunghezze', 'apply'], ['Non trovo il tempo per un massaggio', 'massage'], ['Non ho una routine', 'routine']] },
      { q: 'Cosa cerchi?', o: [['Un prodotto per iniziare', 'one'], ['La routine completa', 'all'], ['Un\'idea regalo', 'gift']] }
    ];
    let qa = [];
    const draw = () => {
      if (qa.length < Q.length) {
        const s = Q[qa.length];
        quiz.innerHTML = `<span class="eyebrow">Domanda ${qa.length + 1} di ${Q.length}</span><div class="progress"><i style="width:${qa.length / Q.length * 100}%"></i></div>
          <h2>${s.q}</h2><div class="qopts">${s.o.map(([t, v]) => `<button data-qa="${v}">${t}${ARROW}</button>`).join('')}</div>
          ${qa.length ? '<button class="rm" id="qback" style="justify-self:start">Torna indietro</button>' : ''}`;
        return;
      }
      const kp = P[KIT];
      let h = KIT, why = 'Nutri Care e Scalp Care insieme ti danno la routine completa' + (kp && kp.compare > kp.price ? `, e risparmi ${eur(kp.compare - kp.price)} con la guida in regalo.` : '.');
      if (qa[2] === 'one') {
        if (qa[1] === 'apply' || qa[0] === 'serum') { h = NUTRI; why = 'Usi già un siero: Nutri Care lo porta direttamente sulla radice, senza sprechi.'; }
        else { h = SCALP; why = 'Parti dal massaggio: due minuti al giorno per rilassare la cute, anche senza siero.'; }
      }
      if (qa[2] === 'gift') why = 'Il Kit Full Care è pronto da regalare, e puoi scegliere il colore di ogni prodotto. La guida è in omaggio.';
      const p = P[h];
      quiz.innerHTML = `<span class="eyebrow">La tua routine</span><div class="progress"><i style="width:100%"></i></div>
        <div class="result"><img src="${p.imgs[1] || p.imgs[0]}" alt="${p.name}"><div class="stack"><h2>${p.name}</h2><p class="lead">${why}</p>
        <div class="price">${eur(p.price)}${p.compare > p.price ? `<s>${eur(p.compare)}</s><small style="display:block;font-size:12.5px;font-weight:400;color:var(--ink-3)">se acquistati separatamente</small>` : ''}</div>
        <div class="row"><button class="btn" data-quick="${h}">Aggiungi al carrello</button><a class="btn ghost" href="${p.url}">Vedi il prodotto</a></div></div></div>
        <button class="rm" id="qreset" style="justify-self:start">Rifai il quiz</button>`;
    };
    quiz.addEventListener('click', e => {
      const b = e.target.closest('[data-qa]'); if (b) { qa.push(b.dataset.qa); draw(); return; }
      if (e.target.id === 'qback') { qa.pop(); draw(); }
      if (e.target.id === 'qreset') { qa = []; draw(); }
    });
    draw();
  }
})();
